const initializeLazyVideos = (container = document) => {
  const lazyVideos = Array.from(container.querySelectorAll("video.lazy-video"));

  if ("IntersectionObserver" in window && lazyVideos.length > 0) {
    const lazyVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          if (video) {
            const sources = video.querySelectorAll("source");
            if (!sources.length) return;

            sources.forEach((source) => {
              if (source.dataset.src) {
                source.src = source.dataset.src;
              }
            });

            video.muted = true;
            video.load();

            video.play().catch((err) => {
              console.warn("Video autoplay failed:", err);
            });

            video.classList.remove("lazy-video");
            lazyVideoObserver.unobserve(video);
          }
        } else {
          if (video && !video.paused) {
            video.pause();
          }
        }
      });
    });

    lazyVideos.forEach((lazyVideo) => {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
};

initializeLazyVideos();

window.initializeLazyVideos = initializeLazyVideos;
